import { render, staticRenderFns } from "./table-item.vue?vue&type=template&id=0204bc16&scoped=true"
import script from "./table-item.vue?vue&type=script&lang=js"
export * from "./table-item.vue?vue&type=script&lang=js"
import style0 from "./table-item.vue?vue&type=style&index=0&id=0204bc16&prod&lang=less&scoped=true"
import style1 from "./table-item.vue?vue&type=style&index=1&id=0204bc16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204bc16",
  null
  
)

export default component.exports